import React, { useEffect, useRef, useState } from 'react'

import { TRUCKORDERSDETAILS } from '../../../Utils/conts';
import { toast } from 'react-toastify';
import { CallApi } from '../../../Components/common/CommonFunctions';

import { ReactComponent as Ovicon } from "../../../assets/images/icon_svg/shipment.svg";
import { ReactComponent as Tkicon } from "../../../assets/images/icon_svg/track.svg";
import { ReactComponent as Cnicon } from "../../../assets/images/icon_svg/plane.svg";
import { ReactComponent as Mlicon } from "../../../assets/images/icon_svg/mail.svg";
import { ReactComponent as Amicon } from "../../../assets/images/icon_svg/clip.svg";  
import { ReactComponent as History_icon } from "../../../assets/images/icon_svg/history_icon.svg"; 
import { ReactComponent as Discrep } from "../../../assets/images/icon_svg/Discrepsis.svg";  

import Overview from './Components/Overview'; 
import Shipments from './Components/Shipments'; 
import Tracking from './Components/Tracking'; 
import Connection from './Components/Connection'; 
import Communication from './Components/Communication'; 
import Attachment from '../../../Components/common/Attachment';
import Discrepancies from './Components/Discrepancies'; 
import History from './Components/History';

const TODetails = ({ onTitleChange }) => {

    const [detID, setDetID] = useState(localStorage.getItem('TODetails'));
    const isMounted = useRef(false);
    const initTab = localStorage.getItem('TOInitialTab') || 'OV';
    const [selectedTab, setSelectedTab] = useState(initTab);
    const [disLoading, setDisLoading] = useState(false)
    const [details, setDetails] = useState({})
    const [sendData, setSendData] = useState({})

    const loadDetails = async (newId) => {

        setDisLoading(true);
        CallApi({
            endPoint: 'airline-order-view-details', // TRUCKORDERSDETAILS
            payload: { id: newId??detID },
            onSuccess: (res) => {
                if (res.data.response_code === 200) {
                    const innerData = res.data.response_data;
                    setDetails({...innerData, id: detID});
                    setSendData({ attType: 'airline_truck_order', id: detID });
                } else {
                    toast.error(res.data.response_msg)
                }
                setDisLoading(false);
            },
            onError: (msg) => toast.error(msg)
        });
    }

   
    const handleTruckChange = (truck) => {
        const newId    = truck?.truck_plan_monitor_mappings_id;
        const newTitle = `${truck?.truck_flight_no || ''}/${truck?.truck_std || ''}`;

        localStorage.setItem('TODetails', newId);
        localStorage.setItem('DetailsTitle', newTitle);

        setDetID(newId);
        loadDetails(newId);
        setSelectedTab('SM');

        onTitleChange?.(newTitle); 
    };

    useEffect(() => {
        localStorage.removeItem('TOInitialTab');
        if (isMounted.current) return;
        loadDetails();
        isMounted.current = true;
    }, []);

    const onChange = (val) => {
        setSelectedTab(val)
    }
    const handleDiscrepancyTruckClick = (data) => {
        const newId = data?.truck_plan_monitor_mapping_id;
        const newTitle = `${data?.truck_number || ''}/${data?.truck_date ? data.truck_date.split(' ')[0] : ''}`;

        localStorage.setItem('TODetails', newId);
        localStorage.setItem('DetailsTitle', newTitle);

        setDetID(newId);
        loadDetails(newId);

        onTitleChange?.(newTitle);
    };
    return (
        <div className="main-content">
            <div className='d-flex justify-content-between tw-74 mb-3'>
                <div className='topNav'>
                    <button onClick={() => onChange('OV')} className={selectedTab === 'OV' ? 'nav_active' : ''}><Ovicon />Overview</button>
                    <button onClick={() => onChange('SM')} className={selectedTab === 'SM' ? 'nav_active' : ''}><Ovicon />Shipments</button>
                    <button onClick={() => onChange('TK')} className={selectedTab === 'TK' ? 'nav_active' : ''}><Tkicon />Tracking</button>
                    <button onClick={() => onChange('CN')} className={selectedTab === 'CN' ? 'nav_active' : ''}><Cnicon />Connection</button>
                    {/* <button onClick={() => onChange('CM')} className={selectedTab === 'CM' ? 'nav_active' : ''}><Mlicon />Communication</button> */}
                    <button onClick={() => onChange('ATT')} className={selectedTab === 'ATT' ? 'nav_active' : ''}><Amicon />Attachments</button>
                    <button onClick={() => onChange('DIS')} className={selectedTab === 'DIS' ? 'nav_active' : ''}><Discrep />Discrepancies</button>
                    <button onClick={() => onChange('HIS')} className={selectedTab === 'HIS' ? 'nav_active' : ''}><History_icon />History</button>
                </div>
            </div>
            {selectedTab === 'OV' && <Overview propData={details} onReload={loadDetails} onDetails={handleDiscrepancyTruckClick} />}
            {selectedTab === 'SM' && <Shipments key={detID} detID={detID} onTruckChange={handleTruckChange} onDetails={handleDiscrepancyTruckClick}/>}
            {selectedTab === 'TK' && <Tracking />}
            {selectedTab === 'CN' && <Connection />}
            {selectedTab === 'CM' && <Communication />}
            {selectedTab === 'ATT' && <div className='attachments_cmn'><Attachment propData={details} submitData={sendData} onReload={loadDetails} /></div>}
            {selectedTab === 'DIS' && <Discrepancies />}
            {selectedTab === 'HIS' && <History />}
        </div>
    )
}

export default TODetails